module.exports = __webpack_public_path__ + "static/img/nopay-img.714b4da.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/nopay-img.png
// module id = uXKV
// module chunks = 1